import axios from 'axios'
import { url } from '../../url/url'

export const homeSlider = async () => {
   return await axios.get(`${url}sliders/`)
}
export const homeTerif = async () => {
   return await axios.get(`${url}tarifs/`)
}
// Годовые пакеты — тот же эндпоинт, выборка по периоду.
// Акционные сюда не попадают: бэк отдаёт по period=year только те, у кого
// не стоит is_promo. Годовые с акцией забираем вторым запросом, ниже.
export const homeTerifYear = async () => {
   return await axios.get(`${url}tarifs/`, { params: { period: 'year' } })
}

// Годовые, у которых стоит и акция: «Тамошо Pro (12+2 мес)» и Pro Max.
// Они годовые и акционные одновременно, поэтому должны быть на обеих
// вкладках, а в выборку period=year сами не попадают. Фильтры на бэке
// комбинируются, так что это те же два тарифа, что и в акциях, — без
// угадывания по названию.
export const homeTerifYearPromo = async () => {
   return await axios.get(`${url}tarifs/`, { params: { period: 'year', is_promo: 'true' } })
}
// Акционные тарифы — тот же эндпоинт, выборка по флагу is_promo.
// Отдельный источник: в GET tarifs/ и ?period=year акционные не подмешиваются.
// Пустой/ошибочный ответ → остаёмся на FALLBACK_ACTION_CARDS (как у годовых).
export const homeTerifAction = async () => {
   return await axios.get(`${url}tarifs/`, { params: { is_promo: 'true' } })
}
